@if (objectForm) {
    <nz-spin [nzSpinning]="loading">
        <form nz-form [formGroup]="objectForm" class="login-form" nzLabelAlign="left">
            @if (!stopTimerMode) {
                <nz-form-item *hasPermission="[GroupPermission.WORK_TIME_ADMIN]">
                    <nz-form-label nzRequired [nzSm]="8" [nzXs]="24" nzFor="startDateTimeUtc" nzLabelWrap>Sākuma datums un laiks</nz-form-label>
                    <nz-form-control clValidationError="startDateTimeUtc" [nzSm]="16" [nzXs]="24">
                        <nz-date-picker
                            style="width: 100%"
                            nz-input
                            id="startDateTimeUtc"
                            formControlName="startDateTimeUtc"
                            nzPlaceHolder="Sākuma datums un laiks"
                            nzShowTime
                            [nzFormat]="dateTimeFormatWithSeconds"
                        ></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
                <nz-form-item *hasPermission="[GroupPermission.WORK_TIME_ADMIN]">
                    <nz-form-label nzRequired [nzSm]="8" [nzXs]="24" nzFor="endDateTimeUtc" nzLabelWrap>Beigu datums un laiks</nz-form-label>
                    <nz-form-control clValidationError="endDateTimeUtc" [nzSm]="16" [nzXs]="24">
                        <nz-date-picker
                            style="width: 100%"
                            nz-input
                            id="endDateTimeUtc"
                            formControlName="endDateTimeUtc"
                            nzPlaceHolder="Beigu datums un laiks"
                            nzShowTime
                            [nzFormat]="dateTimeFormatWithSeconds"
                        ></nz-date-picker>
                    </nz-form-control>
                </nz-form-item>
            }
            <nz-form-item>
                <nz-form-label [nzRequired]="notesRequiredOnEdit" [nzSm]="8" [nzXs]="24" nzFor="notes">Piezīmes/apraksts</nz-form-label>
                <nz-form-control clValidationError="notes" [nzSm]="16" [nzXs]="24">
                    <textarea rows="4" nz-input id="notes" formControlName="notes" placeholder="Piezīmes/apraksts"></textarea>
                </nz-form-control>
            </nz-form-item>
            <div *nzModalFooter class="modal-footer">
                <div class="modal-footer-left">
                    @if (isEditMode && !stopTimerMode) {
                        <cl-info-button
                            [id]="originalObject.id"
                            [entityType]="EntityType.WorkTime"
                            (loadingChanged)="loading = $event"
                        ></cl-info-button>

                        <cl-notification-history-button
                            [entityType]="EntityType.WorkTime"
                            [id]="originalObject.id"
                            class="ml-2"
                        ></cl-notification-history-button>
                    }
                </div>
                <div class="modal-footer-right">
                    <button nz-button nzType="default" [disabled]="loading" (click)="cancel()">Atcelt</button>
                    <button nz-button nzType="primary" [disabled]="loading" (click)="validateAndSave()">Saglabāt</button>
                </div>
            </div>
        </form>
    </nz-spin>
}
